<p>confirm-delete works!</p>
